import React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import './Pagination.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  totalItems = 0,
  itemsPerPage = 10,
  showInfo = true,
  size = 'md'
}) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxPagesToShow = 5;
  
  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
  
  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  // First page
  if (startPage > 1) {
    pages.push(
      <BootstrapPagination.First 
        key="first" 
        onClick={() => onPageChange(1)}
      />
    );
  }

  // Previous page
  pages.push(
    <BootstrapPagination.Prev 
      key="prev" 
      onClick={() => onPageChange(Math.max(1, currentPage - 1))}
      disabled={currentPage === 1}
    />
  );

  // Ellipsis before
  if (startPage > 1) {
    pages.push(<BootstrapPagination.Ellipsis key="ellipsis-start" disabled />);
  }

  // Page numbers
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <BootstrapPagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => onPageChange(i)}
      >
        {i}
      </BootstrapPagination.Item>
    );
  }

  // Ellipsis after
  if (endPage < totalPages) {
    pages.push(<BootstrapPagination.Ellipsis key="ellipsis-end" disabled />);
  }

  // Next page
  pages.push(
    <BootstrapPagination.Next 
      key="next" 
      onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
      disabled={currentPage === totalPages}
    />
  );

  // Last page
  if (endPage < totalPages) {
    pages.push(
      <BootstrapPagination.Last 
        key="last" 
        onClick={() => onPageChange(totalPages)}
      />
    );
  }

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="pagination-wrapper">
      {showInfo && totalItems > 0 && (
        <div className="pagination-info">
          Showing <strong>{startItem}</strong> to <strong>{endItem}</strong> of{' '}
          <strong>{totalItems}</strong> {totalItems === 1 ? 'item' : 'items'}
        </div>
      )}
      <BootstrapPagination size={size} className="mb-0">
        {pages}
      </BootstrapPagination>
    </div>
  );
};

export default Pagination;
